module.exports = __webpack_public_path__ + "pe.20bd6f7b.svg";